import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=b1cc896c&scoped=true&"
import script from "./UiSelect.vue?vue&type=script&lang=js&"
export * from "./UiSelect.vue?vue&type=script&lang=js&"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=b1cc896c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cc896c",
  null
  
)

export default component.exports